import { useTranslation } from 'react-i18next'

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@ps/ds/components/primitives/Select/Select'
import { Globe } from 'lucide-react'
import { NS } from 'src/constants/i18n'
import { LANGUAGE_LABELS, SUPPORTED_LANGUAGES } from 'src/constants/locale'
import { SupportedLanguages } from 'src/types/locale'
import { getCurrentLanguage } from 'src/utils/locale/getCurrentLanguage'
import { selectLanguage } from 'src/utils/locale/selectLanguage'

export const LanguageSelector = () => {
  const { t, i18n } = useTranslation(NS.TRACKING)

  const language = getCurrentLanguage(i18n)
  const changeLanguage = (value: SupportedLanguages) => selectLanguage(i18n, value)

  return (
    <Select value={language} onValueChange={changeLanguage}>
      <SelectTrigger
        className="mx-auto w-full md:w-fit md:min-w-[172px]"
        aria-label={t('language.select.label')}>
        <span>
          <span className="flex flex-row gap-2 items-center">
            <Globe className="h-4 w-4 shrink-0 text-muted-foreground" />
            <SelectValue />
          </span>
        </span>
      </SelectTrigger>

      <SelectContent>
        <SelectGroup>
          {Object.values(SUPPORTED_LANGUAGES).map((lng) => (
            <SelectItem key={lng} value={lng} lang={lng}>
              {LANGUAGE_LABELS[lng]}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
